// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { stringIsNumber } from 'validators/common/simple'
import { MUST_BE_NUMERICAL_VALUE } from 'errors'

const stringMustBeNumber = v => (
  !!v.length && !stringIsNumber(v) && MUST_BE_NUMERICAL_VALUE
)

export default stringMustBeNumber
